import React from "react";
import { connect } from "react-redux";

import { getClubBookingByID } from "state/school_money/selectors";
import { removeClubBookingFromBasket } from "state/school_money/actions";

import Date from "components/Date";
import Currency from "components/Currency";
import RemoveButton from "components/school_money/RemoveButton";

import "./ClubBooking.css";

class ClubBooking extends React.Component {
  
  render() {
    
    const { clubBooking, price, reserve } = this.props;
    const { description, startDate } = clubBooking.toObject();
    
    return (
      <div className="club-booking-basket-item">
        <div className="club-booking-basket-item__label">
          <div className="club-booking-basket-item__description">{description}{reserve ? " (reservation)" : ""}</div>
          <div className="club-booking-basket-item__date">W/C <Date date={startDate} /></div>
        </div>
        <div className="club-booking-basket-item__price">
          <Currency className="club-booking-basket-item__amount" amount={price} />
          <RemoveButton className="club-booking-basket-item__remove-button" onClick={this.props.remove} />
        </div>
      </div>
    );
    
  }
  
}

export default connect(
  (state, { clubBookingID }) => ({
    clubBooking: getClubBookingByID(state, clubBookingID)
  }),
  (dispatch, { clubBookingID }) => ({
    remove: () => dispatch(removeClubBookingFromBasket(clubBookingID))
  })
)(ClubBooking);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/items/clubBooking/ClubBooking.js